import React, { forwardRef } from 'react';
import { PaneProps } from './iLayout';
import classNames from 'classnames';
import { WebUI } from "../../wui-core/src/index";

const Pane = forwardRef<HTMLDivElement, PaneProps>((props, ref) => {
    const {
        children,
        className,
        clsPrefix,
        direction,
        style,
        domKey,
        size,
        fieldid
    } = props;
    const classes = classNames(clsPrefix, className);

    const PaneStyle: React.CSSProperties = {
        flex: 1,
        position: 'relative',
        outline: 'none',
        ...style
    };

    if (size !== undefined) {
        if (direction === 'vertical' || typeof direction === undefined) {
            PaneStyle.width = size;
            PaneStyle.overflow = size ? 'auto' : 'unset';
        } else if (direction === 'horizontal') {
            PaneStyle.height = size;
            PaneStyle.display = 'flex';
        }
        PaneStyle.flex = 'none';
    }

    return (
        <div
            className={classes}
            style={PaneStyle}
            data-domId={domKey}
            fieldid={fieldid}
            ref={ref}
        >
            {children}
        </div>
    );
});

Pane.displayName = 'Pane';

export default WebUI({name: "spliter-pane"})(Pane);